import { Subscription } from 'rxjs';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HostService } from 'src/app/services/host.service';
import { RentingService } from 'src/app/services/renting.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocationSmartService } from 'src/app/services/location-smart.service';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';


@Component({
  selector: "app-proprietaire",
  templateUrl: "./proprietaire.component.html",
  styleUrls: ["./proprietaire.component.scss"],
})
export class ProprietaireComponent implements OnInit, OnDestroy {
  //Subscription
  rentingSubscription: Subscription;
  changeStatusSubscription: Subscription;
  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  statusChanged: boolean;
  rentingGetted: boolean;


 // displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'status', 'date', 'lodger', 'actions'];
  displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'status', 'date', 'actions'];

  dataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  user: any;
  rentings: any;

  afficheAddcars: boolean;
  afficheCoordonnees: boolean;
  affichepermis: boolean;

  currentDate: string | null;

  public currency: string;

  constructor(
    private rentingService: RentingService,
    public hostService: HostService,
    public appService: AppService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private locationSmartService: LocationSmartService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private verifResponsiveService:VerifResponsiveService
  ) {}


    @HostListener('window:resize', ['$event'])
    onResize() {
      if(window.innerWidth<=959)
      {
        this.viewType= 'grid';
      }
      else{
        this.viewType= 'list';
      }
    }
  

  ngOnInit() {

    this.initProperty();
    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      console.log(data);
      this.viewType = data ? 'grid' : 'list';
    });
  }

  private initProperty() {

    let res = this.authService.getUserOfLocalStorage();
    
    if(res.status) {

      this.user = JSON.parse(localStorage.getItem("user")!);

      //Nous vérifions si le profil de l'utilisateur est complet
      let verified = this.authService.verifieProfilOfUser();
      
      this.afficheAddcars = verified.afficheAddcars!;
      this.afficheCoordonnees = verified.afficheCoordonnees!;
      this.affichepermis = verified.affichepermis!

      this.getRenting();

    } else {

      this.rentingGetted = false;

      this.router.navigate(["login"]);
      
    }

    this.statusChanged = false;
    
    this.currentDate =  this.datePipe.transform(Date.now(), 'yyyy-MM-dd')

    this.currency = this.appService.getCurrency();

  }

  public changeStatus(renting: Object, value: string) {

    let result = this.locationSmartService.changeStatus(renting, value, 'owner');

    this.getRenting();
    
  }

  noterReservation(id:number, renting: any)
  {

          let obj = {
            id: id,
          };

          this.spinner.show();

        this.rentingService.envoiMailCar(obj).subscribe(
          (data) => {
            console.log(data);
            this.changeStatus(renting, "TERMINER");
            
            this.toastr.show("Un mail vous a été envoyé et également au locataire pour noter le service","mail envoyé",
              {
                timeOut: 5000,
                closeButton: true,
              } as IndividualConfig,
              "toast-" + "success"
            );
          },
          (error) => {
            this.toastr.show("Le mail n'a pas été envoyé","Erreur Erreur",
              {
                timeOut: 5000,
                closeButton: true,
              } as IndividualConfig,
              "toast-" + "error"
            );
          }
        );
  }

  private getRenting() {

    this.rentingSubscription = this.rentingService.indexOwner(this.user.id).subscribe((rentings: any) => {
     
      this.rentingGetted = true;

      this.rentings = rentings.rentings;
     

      this.dataSource = new MatTableDataSource(rentings.rentings);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    });

  }

  refresh() {
    //window.location.reload();
   //location.reload();
    this.getRenting();
    
  }

  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'owner',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  } 
  
  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

  } 

  ngOnDestroy(): void {
    if (this.rentingGetted) {
      this.rentingSubscription.unsubscribe();
    }

    if (this.statusChanged) {
      this.changeStatusSubscription.unsubscribe();
    }
  }

   
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}


